// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_js_exceptions = require("rescript/lib/js/caml_js_exceptions.js");
var ImagekitJavascript = require("imagekit-javascript");
var Config__ImageKit$SmartcutsMacros = require("../Config__ImageKit.bs.js");

var InitParams = {};

var client = new ImagekitJavascript({
      publicKey: Config__ImageKit$SmartcutsMacros.publicKey,
      urlEndpoint: "https://ik.imagekit.io/" + Config__ImageKit$SmartcutsMacros.id,
      authenticationEndpoint: process.env.HOSTNAME + "/api/imagekit_auth"
    });

var UploadWithBlobParams = {};

var UploadWithBase64Params = {};

var UploadResult = {};

function uploadWithBlob(params, client) {
  return new Promise((function (resolve, reject) {
                try {
                  client.upload(params, (function (nullableErr, result) {
                          if (nullableErr == null) {
                            return resolve(result);
                          } else {
                            return reject(nullableErr);
                          }
                        }));
                  return ;
                }
                catch (raw_exn){
                  var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  return reject(exn);
                }
              }));
}

function uploadWithBase64(params, client) {
  return new Promise((function (resolve, reject) {
                try {
                  client.upload(params, (function (nullableErr, result) {
                          if (nullableErr == null) {
                            return resolve(result);
                          } else {
                            return reject(nullableErr);
                          }
                        }));
                  return ;
                }
                catch (raw_exn){
                  var exn = Caml_js_exceptions.internalToOCamlException(raw_exn);
                  return reject(exn);
                }
              }));
}

exports.InitParams = InitParams;
exports.client = client;
exports.UploadWithBlobParams = UploadWithBlobParams;
exports.UploadWithBase64Params = UploadWithBase64Params;
exports.UploadResult = UploadResult;
exports.uploadWithBlob = uploadWithBlob;
exports.uploadWithBase64 = uploadWithBase64;
/* client Not a pure module */
